import React, { useState } from "react";
import { withTranslation, useTranslation } from "react-i18next";
import { Modal } from "react-responsive-modal";
import Mustache from "mustache";
import ReactHtmlParser from "react-html-parser";

const Terms = (props) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [terms, setTerms] = useState([]);

  const variables = {
    company: t("TERMS_OF_SERVICE_COMPANY"),
    brand: t("TERMS_OF_SERVICE_BRAND"),
    safe_harbor_url: t("TERMS_OF_SERVICE_SAFE_HARBOR_URL"),
    email: t("TERMS_OF_SERVICE_EMAIL"),
    cookie_url: t("TERMS_OF_SERVICE_COOKIE_URL"),
  };

  const preTitles = (term) =>
    Array.isArray(term.preTitle) ? term.preTitle : [term.preTitle];
  const titles = (term) =>
    Array.isArray(term.title) ? term.title : [term.title];
  const popupTexts = (term) =>
    Array.isArray(term.popupText) ? term.popupText : [term.popupText];

  const onOpenModal = (modalTitle, modalDescription) => {
    setTitle(modalTitle);
    setDescription(Mustache.render(modalDescription, variables));
    setOpen(true);
  };
  const onCloseModal = () => {
    setTitle("");
    setDescription("");
    setOpen(false);
    const html = document.querySelector("html");
    html.style = "";
  };

  const handleCheckboxes = (event) => {
    if (event) {
      if (event.target.checked) {
        setTerms([...terms, event.target.name]);
      } else {
        setTerms([...terms.filter((item) => item !== event.target.name)]);
      }
      if (Object.keys(props.terms).includes(event.target.name)) {
        const returnObj = {
          name: "terms",
          value: { ...props.terms, [event.target.name]: event.target.checked },
        };
        props.handleChange({ target: returnObj });
      } else {
        props.handleChange({
          target: {
            name: event.target.name,
            value: event.target.checked,
          },
        });
      }
    }
  };

  const customTermStyles = {
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      zIndex: "20",
      outline: "none",
      border: "none",
      width: "30px",
    },
    modal: {
      position: "relative",
      padding: "0",
      width: "100%",
      minHeight: "100%",
    },
    overlay: {
      padding: "0",
    },
  };

  const parseString = (str, className, color, fontSize) => {
    const regex = /\{(.*?)\}/g;
    return str.split(regex).map((part, index) => {
      const parts = part.split("|");
      const linkName = parts[0];
      const linkOrKey = parts[1];
      const type = parts[2];
      if (type === "POPUP") {
        return (
          <span
            key={index}
            style={{ color, fontSize }}
            className={className}
            onClick={() => onOpenModal(linkName, t(linkOrKey, variables))}>
            {linkName}
          </span>
        );
      } else if (type === "LINK") {
        return (
          <span
            key={index}
            style={{ color, fontSize }}
            className="type-regular small">
            <a
              className={className}
              style={{ color, fontSize }}
              target="_blank"
              rel="noreferrer"
              href={linkOrKey}>
              {linkName}
            </a>
          </span>
        );
      } else {
        return <React.Fragment key={index}>{part}</React.Fragment>;
      }
    });
  };

  return (
    <div className={`${props.copyright ? 'copyright-section': 'term-section'} flex flex-col ${props.noPadding ? "" : "mb-12"}`}>
      <ul className="preCheckinSubTitle whitespace-pre-line">
        {props.allTerms &&
          props.allTerms.map((term, index) => (
            <React.Fragment key={index}>
              <li
                className="mb-5"
                style={{ background: "none", padding: 0 }}>
                {term.name && (
                  <>
                    <div className="inline-flex items-start mb-4">
                      <div className="w-8 mr-4 flex items-center">
                        <label
                          htmlFor={term.name}
                          style={{
                            color: props.regexFormColor || "#636363",
                            fontSize: props.regexFormFontSize || "12px"
                          }}>
                          <input
                            id={term.name}
                            name={term.name}
                            onChange={handleCheckboxes}
                            type="checkbox"
                            value="true"
                            required={!term.defaultText}
                            className="hidden"
                          />
                          <svg
                            role="img"
                            className={`w-8 h-8 ${
                              terms.includes(term.name) ? "hidden" : "block"
                            }`}
                            preserveAspectRatio="xMidYMid meet"
                            viewBox="0 0 1408 1408">
                            <path
                              d="M1120 128H288q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113V288q0-66-47-113t-113-47zm288 160v832q0 119-84.5 203.5T1120 1408H288q-119 0-203.5-84.5T0 1120V288Q0 169 84.5 84.5T288 0h832q119 0 203.5 84.5T1408 288z"
                              fill={
                                terms.includes(term.name)
                                  ? "none"
                                  : props.backgroundColorTopBar
                              }
                            />
                          </svg>
                          <svg
                            role="img"
                            className={`w-8 h-8 ${
                              terms.includes(term.name) ? "block" : "hidden"
                            }`}
                            preserveAspectRatio="xMidYMid meet"
                            viewBox="0 0 1664 1408">
                            <path
                              d="M1408 802v318q0 119-84.5 203.5T1120 1408H288q-119 0-203.5-84.5T0 1120V288Q0 169 84.5 84.5T288 0h832q63 0 117 25q15 7 18 23q3 17-9 29l-49 49q-10 10-23 10q-3 0-9-2q-23-6-45-6H288q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113V866q0-13 9-22l64-64q10-10 23-10q6 0 12 3q20 8 20 29zm231-489l-814 814q-24 24-57 24t-57-24L281 697q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263l647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z"
                              fill={
                                terms.includes(term.name)
                                  ? props.backgroundColorTopBar
                                  : "none"
                              }
                            />
                          </svg>
                        </label>
                      </div>
                      <div className="break-words subtitle">
                        {term.defaultText ? (
                          <p className="type-regular small leading-7">
                            <label
                              htmlFor={term.name}
                              style={{
                                color: props.regexFormColor || "#636363",
                                fontSize: props.regexFormFontSize || "12px"
                              }}
                            >
                              {term.defaultText}
                            </label>
                          </p>
                        ) : (
                          <p className="type-regular small leading-7 subtitle">
                            {preTitles(term).map((item, index) => (
                              <React.Fragment key={index}>
                                <label
                                  htmlFor={term.name}
                                  style={{
                                    color: props.regexFormColor || "#636363",
                                    fontSize: props.regexFormFontSize || "12px"
                                  }}
                                >
                                  {item
                                    ? item
                                    : parseString(
                                        titles(term)[index],
                                        "font-bold underline cursor-pointer",
                                        props.backgroundColorTopBar
                                      )}
                                </label>
                                &nbsp;
                                {term.popupText && (
                                  <span
                                    className="font-bold underline cursor-pointer"
                                    style={{
                                      color: props.backgroundColorTopBar,
                                    }}
                                    onClick={() =>
                                      onOpenModal(
                                        titles(term)[index],
                                        popupTexts(term)[index]
                                      )
                                    }>
                                    {titles(term)[index]}
                                  </span>
                                )}
                                &nbsp;
                              </React.Fragment>
                            ))}
                            <span className="text-gray-400 type-regular small pl-2">
                              *{props.t("REQUIRED")}
                            </span>
                          </p>
                        )}
                      </div>
                    </div>
                    {props.errors && props.errors[term.name] && (
                      <p className="text-14 text-red-500 pl-10">
                        {props.errors[term.name].join(". ")}
                      </p>
                    )}
                  </>
                )}
                {term.descriptionHtml && (
                  <div
                    className="text-justify pl-12 py-4 leading-7"
                    dangerouslySetInnerHTML={{
                      __html: term.descriptionHtml,
                    }}></div>
                )}
                {term.regexForm &&
                  term.regexForm.map((submitForm, index) => {
                    return (
                      <div
                        key={index}
                        className={`py-4 leading-7 ${
                          !props.noPadding
                            ? "text-justify pl-12"
                            : "text-center"
                        }`}
                        style={{
                          color: props.regexFormColor || "#636363",
                          fontSize: props.regexFormFontSize || "12px",
                        }}>
                        {parseString(
                          submitForm,
                          "font-bold underline cursor-pointer type-regular",
                          props.regexFormColor || "#636363",
                          props.regexFormFontSize || "12px"
                        )}
                      </div>
                    );
                  })}
              </li>
            </React.Fragment>
          ))}
      </ul>
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        styles={customTermStyles}>
        <div className="relative">
          <h2 className="py-6 text-center text-16 preCheckinTitle h-16 bg-white w-full">
            {title}
          </h2>
          <div className="text-14 preCheckinSubTitle leading-8 max-h-full overflow-y-auto relative">
            <p
              className="p-8 max-h-full"
              style={{ whiteSpace: "pre-wrap" }}>
              {ReactHtmlParser(description)}
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default withTranslation()(Terms);
